import { useI18n } from 'next-localization';

import { Badges } from '@/components/badges';
import { cn } from '@/lib/utils';

import styles from '../../listing.module.css';

type FooterSectionProps = {
  acceptsNewPatients: boolean;
  telehealthProvider: boolean;
};

export const FooterSection = ({
  acceptsNewPatients,
  telehealthProvider,
}: FooterSectionProps): JSX.Element => {
  const { t } = useI18n();

  return (
    <div className="col-md-12">
      <div className="mt-2 d-none d-md-block">
        <Badges
          acceptsNewPatients={acceptsNewPatients}
          telehealthProvider={telehealthProvider}
          className={cn('fw-bold', styles.badgeGap)}
        />
      </div>
      <div className={cn('py-2', styles.selfPayment)}>
        <span className="neu-text--regular">{t('OAS.Profile.Details.SelfPayPatient')}</span>
      </div>
    </div>
  );
};
